import React from 'react';
import { Shield, Users, MapPin, AlertTriangle } from 'lucide-react';

const DisclaimerPage = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back Button */}
        <button
          onClick={onBack}
          className="mb-6 text-blue-600 hover:text-blue-800 flex items-center gap-2"
        >
          ← Back to Home
        </button>

        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Legal Disclaimer</h1>
          
          {/* Core Disclaimer */}
          <section className="mb-8">
            <div className="flex items-center gap-3 mb-4">
              <Shield className="w-6 h-6 text-blue-600" />
              <h2 className="text-xl font-semibold text-gray-900">Disclaimer</h2>
            </div>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 leading-relaxed">
                AbleFam (including AbilityHub and Family Assist tools) is provided for <strong>informational and community support purposes only</strong>. The content on this site is <strong>not intended to be, and should not be relied upon as, medical, legal, educational, therapeutic, or professional advice</strong>.
              </p>
              <p className="text-gray-700 leading-relaxed mt-4">
                AbleFam does not provide diagnoses, treatment recommendations, legal representation, or individualized educational determinations. Any tools, resources, checklists, examples, or suggestions offered are intended to support families in understanding options and preparing for conversations with qualified professionals.
              </p>
              <p className="text-gray-700 leading-relaxed mt-4">
                Users are encouraged to consult appropriate licensed professionals, including but not limited to medical providers, attorneys, educators, and school representatives, regarding their specific circumstances.
              </p>
              <p className="text-gray-700 leading-relaxed mt-4">
                AbleFam makes no guarantees regarding outcomes, accuracy, completeness, or suitability of information for any particular purpose. Use of this site and its content is at the user's own discretion and risk.
              </p>
            </div>
          </section>

          {/* Community Content Disclaimer */}
          <section className="mb-8">
            <div className="flex items-center gap-3 mb-4">
              <Users className="w-6 h-6 text-blue-600" />
              <h2 className="text-xl font-semibold text-gray-900">Community Content</h2>
            </div>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 leading-relaxed">
                Some content on AbleFam is contributed by community members. These contributions reflect personal experiences and opinions and <strong>do not represent verified recommendations or endorsements by AbleFam</strong>.
              </p>
              <p className="text-gray-700 leading-relaxed mt-4">
                AbleFam does not independently verify all user-submitted information and is not responsible for the accuracy, safety, or outcomes associated with community-shared content. Users are encouraged to exercise discretion and conduct their own research before acting on information provided by others.
              </p>
            </div>
          </section>

          {/* Accessibility Information Disclaimer */}
          <section className="mb-8">
            <div className="flex items-center gap-3 mb-4">
              <MapPin className="w-6 h-6 text-blue-600" />
              <h2 className="text-xl font-semibold text-gray-900">Accessibility Information</h2>
            </div>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 leading-relaxed">
                Accessibility information provided on this site is shared to the best of our knowledge at the time of submission and may change. AbleFam cannot guarantee that venues, events, or services will meet individual accessibility needs. Users are encouraged to contact venues directly to confirm accommodations.
              </p>
            </div>
          </section>

          {/* Emergency Disclaimer */}
          <section className="mb-8">
            <div className="flex items-center gap-3 mb-4">
              <AlertTriangle className="w-6 h-6 text-red-600" />
              <h2 className="text-xl font-semibold text-gray-900">Not for Emergency Use</h2>
            </div>
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <p className="text-gray-700 leading-relaxed">
                AbleFam is not intended for use in emergency situations. If you or someone in your care is experiencing an emergency, please contact local emergency services immediately by calling <strong>911</strong>.
              </p>
            </div>
          </section>

          {/* Last Updated */}
          <div className="text-sm text-gray-500 pt-6 border-t border-gray-200">
            Last updated: January 2025
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerPage;
